import { NASSelectedProductFragment } from '@websky/graphql';
import { DataLayerService } from '../OrderDataLayer/types';
import { CheckoutCheckinOrder } from '../types';

import Base from './Base';
import WebskyServicesAnalytics from '../WebskyServicesAnalytics';
import { Diff } from './types';

class Nas extends Base {
	protected orderBeforeChange: CheckoutCheckinOrder;
	protected orderAfterChange: CheckoutCheckinOrder;

	constructor(orderBeforeChange: CheckoutCheckinOrder, orderAfterChange: CheckoutCheckinOrder) {
		super(orderBeforeChange, orderAfterChange);
	}

	private createServicesTravellersMap(services: NASSelectedProductFragment[] = []): Map<string, Set<string>> {
		return new Map(
			services.map(service => [service.product.id, new Set(service.travellers.map(traveller => traveller.id))])
		);
	}

	public diff(): Diff {
		const added: DataLayerService[] = [];
		const removed: DataLayerService[] = [];

		const servicesMap = new Map(
			this.orderAfterChange?.additionalServices?.nas?.services?.map(service => [service.id, service]) ?? []
		);

		const travellersMap = new Map(
			this.orderAfterChange?.travellers?.map(traveller => [traveller.id, traveller]) ?? []
		);

		const beforeServicesTravellersIdsMap = this.createServicesTravellersMap(
			this.orderBeforeChange?.additionalServices?.nas?.selectedServices
		);

		const afterServicesTravellersIdsMap = this.createServicesTravellersMap(
			this.orderAfterChange?.additionalServices?.nas?.selectedServices
		);

		const allProductsIds = new Set([
			...beforeServicesTravellersIdsMap.keys(),
			...afterServicesTravellersIdsMap.keys()
		]);

		allProductsIds.forEach(productId => {
			const nasService = servicesMap.get(productId);

			if (nasService) {
				const beforeTravellersIds = beforeServicesTravellersIdsMap.get(productId) || new Set();
				const afterTravellersIds = afterServicesTravellersIdsMap.get(productId) || new Set();

				afterTravellersIds.forEach(travellerId => {
					if (!beforeTravellersIds.has(travellerId)) {
						added.push(
							WebskyServicesAnalytics.convertNasServiceToDataLayer(
								nasService,
								this.orderAfterChange?.travellers ?? [],
								travellersMap.get(travellerId).type
							)
						);
					}
				});

				beforeTravellersIds.forEach(travellerId => {
					if (!afterTravellersIds.has(travellerId)) {
						removed.push(
							WebskyServicesAnalytics.convertNasServiceToDataLayer(
								nasService,
								this.orderAfterChange?.travellers ?? [],
								travellersMap.get(travellerId).type
							)
						);
					}
				});
			}
		});

		return { added, removed };
	}
}

export default Nas;
